import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { setQuestion } from 'src/app/actions/question.actions';
import { Question, QuestionData } from 'src/app/models/question.model';
import { Test } from 'src/app/models/test.model';
import { fromQuestion } from 'src/app/reducers/question.reducer';
import { fromTest } from 'src/app/reducers/test.reducer';
import { QuestionService } from 'src/app/services/question.service';
import { UtilsService } from 'src/app/services/utils.service';
import Typewriter from 'typewriter-effect/dist/core';

@Component({
  selector: 'ct-digital-question',
  templateUrl: './digital-question.component.html',
  styleUrls: ['./digital-question.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DigitalQuestionComponent implements OnInit {

  public question$: Observable<Question>;
  public test$: Observable<Test>;

  public currentTest: Test;
  public currentQuestion: Question;
  public questionType: string;
  public timeRemaining: number;
  public timeSpent: number;
  public optionId: number;

  public timeInterval;
  public firstAnimation = true;

  public questionData: QuestionData;

  constructor(
    private store: Store,
    private questionService: QuestionService,
    private utilsService: UtilsService
  ) { }

  ngOnInit(): void {
    // obtenemos los datos de la pregunta y el test de la store
    this.test$ = this.store.pipe(select(fromTest.selectTestState));
    this.question$ = this.store.pipe(select(fromQuestion.selectQuestionState));

    this.test$.pipe(take(1)).subscribe(test => {
      this.currentTest = test;
    }, error => {
      console.log(error);
    });

    this.question$.subscribe(questions => {
      this.questionData = questions.questions[0];
      clearInterval(this.timeInterval);
      this.currentQuestion = questions;

      if (this.questionData.position === 1) {
        this.firstAnimation = true;
      }

      setTimeout(() => {
        this.animations();
      }, 500);

      // comprobamos el timpo de pregunta que estamos recibiendo
      if (questions?.testModelId) {
        if (this.questionData.media) {
          if (this.questionData.media.includes('audio')) {
            this.questionType = 'audio';
          } else {
            this.questionType = 'image';
          }
        } else if (this.questionData.title) {
          this.questionType = 'longQuestion';
        } else if (this.questionData) {
          this.questionType = 'shortQuestion';
        }
      } else {
        console.log('error');
      }

      const now = new Date();
      const utcNow = new Date(now.getTime() + now.getTimezoneOffset() * 60000);
      const levelStartedAt = new Date(questions.levelStartedAt);
      const levelEndsAt = levelStartedAt.getTime() + (questions.maxLevelDuration * 1000);
      let difference = (levelEndsAt - utcNow.getTime()) / 1000;

      this.timeInterval = setInterval(() => {
        difference >= 0 ? difference-- : difference = 0;
        this.timeRemaining = Math.round(difference / 60);
        this.timeSpent = questions.maxLevelDuration / 60 - this.timeRemaining;
      }, 1000);

    }, error => {
      console.log(error);
    });
  }

  public setAnswer() {
    document.querySelector('.nextQuestionButton').setAttribute('disabled', '');

    // comprobamos si hay una respuesta contestada
    if (this.optionId) {

      this.question$.pipe(take(1)).subscribe(question => {
        if (this.questionType === 'audio') {
          document.querySelector('audio').pause();
        }
      }, error => {
        console.log(error);
      });

      this.animationsBetweenQuestions();

      if (this.currentTest == null) {
        this.test$.pipe(take(1)).subscribe(test => {
          this.currentTest = test;
          this.putAnswer();
        }, error => {
          console.log(error);
        });
      } else {
        this.putAnswer();
      }
    }
  }

  putAnswer() {
    this.questionService.putAnswer(this.currentTest.token, [this.optionId]).subscribe(res => {
      // si el nivel no esta completado preguntamos por la siguiente pregunta
      // if (!res.levelCompleted) {
      window.scroll(0, 0);
      this.questionService.getNextQuestion(this.currentTest.token).subscribe(questions => {
        this.store.dispatch(setQuestion(questions));
      }, error => {
        console.log(error);
      });

      this.optionId = undefined;

    }, error => {
      console.log(error);
    });
  }

  animations() {
    const thinking = document.querySelector('.question') as HTMLElement;
    const question = document.querySelector('.typewriter') as HTMLElement;

    if (!thinking || !question) {
      return;
    }

    thinking.style.display = 'inline-block';

    const waitFirstQuestion = 2400;
    const waitQuestions = waitFirstQuestion / 6;
    const waitOptions = waitQuestions / 2.5;

    const pause = this.firstAnimation ? waitFirstQuestion : waitQuestions;

    setTimeout(() => {
      thinking.style.display = 'none';
      question.classList.remove('animate__bounceOut');
      question.style.display = 'inline-block';
    }, pause);

    const typewriter = new Typewriter(document.querySelector('.typewriter'), { delay: 12 });

    typewriter
      .pauseFor(pause + waitQuestions)
      .typeString(this.currentQuestion.questions[0].description.replace(/<\/?[^>]+(>|$)/g, '')) // Quitar html para evitar conflictos con typewriter
      .start()
      .callFunction(() => {
        const cursor = document.querySelector('.Typewriter__cursor') as HTMLElement;
        if (cursor) {
          cursor.style.display = 'none';
        }

        const options = [...document.querySelectorAll('.questionOption')] as HTMLElement[];
        let timeout = waitOptions;
        for (const option of options) {
          setTimeout(() => {
            option.classList.add('animate__animated', 'animate__fadeInLeft');
            option.style.visibility = 'visible';
          }, timeout);
          timeout += waitOptions;
        }
      });

    this.firstAnimation = false;
  }

  animationsBetweenQuestions() {
    const thinking = document.querySelector('.question') as HTMLElement;
    const question = document.querySelector('.typewriter') as HTMLElement;

    question.classList.add('animate__bounceOut');

    setTimeout(() => {
      thinking.style.display = 'inline-block';
    }, 750);

    const options = [...document.querySelectorAll('.questionOption')] as HTMLElement[];

    let timeout = 100;
    for (const option of options) {
      setTimeout(() => {
        option.classList.add('animate__flipOutX');
      }, timeout);
      timeout += 50;
    }
  }

}
